import { useEffect, useState } from "react";
import { Form, Modal, Row } from "react-bootstrap";

export const ConfigAutoGenNoModal = ({
    showAutoGenModal,
    setShowAutoGenModal,
    configModuleType,
    handleAutoNumber,
    configType, setConfigType, prefix, setPrefix, nextNumber, setNextNumber, configData, id
}) => {
    let [autoLabel, setAutoLabel] = useState('')
    let [manualLabel, setManualLabel] = useState('')

    useEffect(() => {
        let moduleAutoGenData = configData?.filter((data) => data.moduleId === id)
        if (moduleAutoGenData?.length) {
            setPrefix(moduleAutoGenData?.[0]?.prefix)
            setConfigType(moduleAutoGenData?.[0]?.configType)
            setNextNumber(moduleAutoGenData?.[0]?.nextNumber)
        }
    }, [])

    useEffect(() => {
        setAutoLabel(`Continue auto-generating ${configModuleType.toLowerCase()} numbers`)
        setManualLabel(`Enter ${configModuleType.toLowerCase()} numbers manually`)
        let moduleAutoGenData = configData?.filter((data) => data.moduleId === id)
        if (moduleAutoGenData?.length) {
            setPrefix(moduleAutoGenData?.[0]?.prefix)
        } else {
            if (configModuleType === 'Quotes')
                setPrefix('QT-')
            if (configModuleType === 'Sales Orders')
                setPrefix('SO-')
            if (configModuleType === 'Invoices')
                setPrefix('INV-')
        }
    }, [configModuleType])

    const handleSave = () => {
        let obj = {
            config_type: configType,
            prefix: prefix,
            next_number: nextNumber
        }
        handleAutoNumber(obj)
    }

    return (
        <Modal
            show={showAutoGenModal}
            onHide={() => setShowAutoGenModal(false)}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>Configure {configModuleType} Number Preferences</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Your {configModuleType.toLowerCase()} numbers are set on auto-generate mode to save your time.
                    Are you sure about changing this setting?</p>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Check
                            type="radio"
                            label={autoLabel}
                            value="autogen"
                            className="fw-semibold"
                            checked={configType === "autogen"}
                            onChange={(e) => setConfigType(e.target.value)}
                        />
                        {configType === 'autogen' &&
                            <Row>
                                <div className="col-6">
                                    <Form.Label>Prefix</Form.Label>
                                    <Form.Control
                                        value={prefix}
                                        onChange={(e) => setPrefix(e.target.value)}
                                        type="text"
                                        name="prefix"
                                    />
                                </div>
                                <div className="col-6">
                                    <Form.Label>Next Number</Form.Label>
                                    <Form.Control
                                        value={nextNumber}
                                        onChange={(e) => setNextNumber(e.target.value)}
                                        type="number"
                                        name="nextNumber"
                                    />
                                </div>
                            </Row>
                        }
                        <Form.Check
                            type="radio"
                            label={manualLabel}
                            value="manual"
                            checked={configType === "manual"}
                            onChange={(e) => setConfigType(e.target.value)}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <button
                    className="btn btn-outline-primary btn-blue"
                    onClick={() => setShowAutoGenModal(false)}>
                    Cancel
                </button>
                <button
                    className="btn btn-primary btn-blue"
                    onClick={handleSave}
                // onClick={() => {
                //     setShowAutoGenModal(false)
                // }}
                >Save</button>
            </Modal.Footer>
        </Modal>
    )
};